var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 58,
    viewBox: "0 0 80 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5092 58.1051H49.5791H46.0973H45.3453V40.7614H51.0176C52.4561 40.7614 53.3061 39.1267 52.4561 37.9498L41.4221 22.6821C40.7192 21.7013 39.2644 21.7013 38.5615 22.6821L27.5276 37.9498C26.6776 39.1267 27.5112 40.7614 28.9661 40.7614H34.6383V58.1051H33.8864H30.4046H15.4148C6.83286 57.631 0 49.6049 0 40.9085C0 34.9093 3.25296 29.6784 8.07519 26.8505C7.63384 25.6572 7.40499 24.3821 7.40499 23.0417C7.40499 16.9118 12.358 11.9588 18.4879 11.9588C19.812 11.9588 21.087 12.1876 22.2803 12.629C25.8275 5.10957 33.4777 -0.10498 42.3703 -0.10498C53.8782 -0.0886339 63.3592 8.72216 64.4381 19.9522C73.2816 21.4725 80 29.6621 80 38.9306C80 48.8366 72.2844 57.4185 62.5092 58.1051Z",
    fill: "#9197A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.cd878c8f5e9bea7ed86fcceb92354467.svg";
export { ForwardRef as ReactComponent };